function formatDate(date: Date) {
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
}

export default function getDefaultDateRange() {
  const startDate = new Date();
  startDate.setMonth(startDate.getMonth() - 8);

  return {
    startDate: formatDate(startDate),
    endDate: "",
    filterLabel: "Latest offerings",
    filterOptionLabel: "Recently added",
  };
}
